import { render, staticRenderFns } from "./lp-checkbox.vue?vue&type=template&id=2dd4be12&"
import script from "./lp-checkbox.vue?vue&type=script&lang=js&"
export * from "./lp-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./lp-checkbox.vue?vue&type=style&index=0&id=2dd4be12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports